import React from "react";

//* MUI Components
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

//* Icons
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

//* ndbx Components
import { Section } from "@arp/react-ndbx";

//* Config
import { saveScript } from "../../../config/disclaimers/disclaimers";

//** Hooks */
import { getModalDefaultStyle } from "../../../utilities/getFontValues";

//---------------------------------------
export default function SaveScriptModal({
	openSaveScriptModal,
	handleSaveScriptModal,
	quoteNumber,
}) {
	const theme = useTheme();
	const style = getModalDefaultStyle(theme);

	return (
		<Modal open={openSaveScriptModal} onClose={handleSaveScriptModal}>
			<Box sx={style} data-identifier="save-script-modal">
				<Section
					sx={{
						display: "flex",
						justifyContent: "end",
						alignItems: "center",
						mt: 2,
						mb: 0,
						mr: { xs: 1, sm: 4 },
						position: "sticky",
						top: { xs: 16, sm: 24 },
					}}
				>
					<CloseIcon
						onClick={handleSaveScriptModal}
						justify="center"
						alignItems="center"
						sx={{ cursor: "pointer" }}
					></CloseIcon>
				</Section>
				<Section
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						top: { xs: 16, sm: 24 },
					}}
				>
					<CheckCircleIcon
						justify="center"
						alignItems="center"
						sx={{ color: "green", fontSize: "4.6rem" }}
					></CheckCircleIcon>
				</Section>
				<Section sx={{ mt: 3, mb: 1, mx: { xs: 1, sm: 7 }, textAlign: "left" }}>
					<Typography variant="p2">
						{saveScript({ quoteNumber: quoteNumber }).SCRIPT_REVIEW}
					</Typography>
				</Section>
			</Box>
		</Modal>
	);
}

{
	/* paymentConfirmationDisclaimers({
	isOnline: true,
}).welcomePackInfo[0].WELCOME_PACK.title; */
}
